import styled, { css } from 'styled-components';

type AccentProps = {
  $accent: string;
};

export const Card = styled.article<AccentProps>`
  ${({ theme, $accent }) => css`
    min-width: 0;
    min-height: 19rem;
    padding: ${theme.spacings[20]};
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid ${theme.colors.gray200};
    border-left: 5px solid ${$accent};
    border-radius: ${theme.radius.md};
    background: ${theme.colors.white};
    box-shadow: 0 0.8rem 2.4rem rgba(36, 44, 92, 0.08);
  `}
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacings[12]};
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    max-width: 24rem;
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.sm};
    font-weight: ${theme.font.weights.semiBold};
    line-height: 1.35;
  `}
`;

export const IconBox = styled.div<AccentProps>`
  ${({ theme, $accent }) => css`
    width: 4rem;
    height: 4rem;
    flex: 0 0 4rem;
    display: grid;
    place-items: center;
    border-radius: ${theme.radius.sm};
    background: ${$accent}16;
    color: ${$accent};
    font-size: 2.2rem;
  `}
`;

export const MainValue = styled.strong`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[16]};
    overflow: hidden;
    color: ${theme.colors.indigo800};
    font-size: clamp(2.4rem, 2vw, 3.2rem);
    font-weight: ${theme.font.weights.bold};
    line-height: 1.1;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

export const Unit = styled.span`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[4]};
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.xs};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[8]};
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.xs};
    line-height: 1.4;
  `}
`;

export const ExtraData = styled.div`
  ${({ theme }) => css`
    margin-top: auto;
    padding-top: ${theme.spacings[16]};
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: ${theme.spacings[12]};
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.xs};

    span {
      line-height: 1.3;
    }

    strong {
      flex-shrink: 0;
      color: ${theme.colors.indigo800};
      font-size: ${theme.font.sizes.sm};
      font-weight: ${theme.font.weights.bold};
      text-align: right;
    }
  `}
`;
